module.exports = __webpack_public_path__ + "img/opp1.2a6b2031.png";